import Layout from '../../internal/Layout.vue'
import ContractsPage from './contracts.vue'
import ManageContract from './components/ManageContract.vue'

const ContractsRoutes = {
  component: Layout,
  children: [
    {
      name: 'contract',
      path: '/',
      component: ContractsPage,
      meta: {
        module: 'contratos',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'newContract',
      path: '/newContract',
      component: ManageContract,
      meta: {
        module: 'contratos',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'editContract',
      path: '/editContract/:contractId',
      component: ManageContract,
      props: true,
      meta: {
        module: 'contratos',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default ContractsRoutes
